import styles from './styles.module.scss';


export default function Card({feedback,deletarMembro}) {
    return (
        <div className={styles.card}>
            <p>{feedback.content}</p>
            <button onClick={() => deletarMembro(feedback.id)} className={styles.delete}>Deletar</button>

        </div>

    )

}